export default __webpack_public_path__ + "static/O0265-397ea12511386fb0af10dcb60bce3a2b.png";